import axios from "axios";
import { apiURL } from "../../utils";

/**
 * Returns the logged-in user's detail object from localStorage, or null.
 * The stored object uses the backend's fld* keys (e.g. fldi_id, fldv_email).
 */
export const getUserData = () => {
  try {
    if (!window.localStorage.getItem("login_status")) return null;
    const raw = localStorage.getItem("user_detail");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const splitName = (fullName) => {
  const parts = (fullName || "").trim().split(/\s+/);
  const firstName = parts.shift() || "";
  const lastName = parts.join(" ");
  return { firstName, lastName };
};

export const teacherApi = {
  /**
   * Logs/tracks a visiting-card download on the backend.
   * Mirrors the payload shape used by the legacy TR-For-Teacher form.
   */
  async downloadVisitingCard(params) {
    const { firstName, lastName } = splitName(params.fullName);
    const isRegistered = params.isRegistered === "1";

    const body = {
      body: {
        firstName,
        lastName,
        contact: params.contact || "",
        email: params.email || "",
        address: params.address || "",
        schoolName: params.schoolName || "",
      },
      isRegistered,
    };

    // Include user_id only for registered users, matching the legacy API.
    if (isRegistered && params.user_id) {
      body.user_id = params.user_id;
    }

    const headers = {
      "content-type": "application/json",
      Accept: "application/json",
    };

    const response = await axios.post(
      apiURL("teacher/download_visiting_card"),
      body,
      { headers }
    );
    return response.data;
  },
};

export default teacherApi;
